class SpaLinkTag extends HTMLAnchorElement {
	static get observedAttributes() {
		return ['href'];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (name === 'href' && newValue?.includes('://')) {
			// need diff and restore original value
			this.rel = 'noopener noreferrer';
		}
	}
}

export const SpaLinkTagName = 'vh-link';

export function registerSpaLinkTag() {
	if (!customElements.get(SpaLinkTagName)) {
		customElements.define(SpaLinkTagName, SpaLinkTag, {
			extends: 'a',
		});
	}
}
